export default "/images/git-pull-request.svg?f4175c149b03388cf3e55933eb0a19af";